import '../styles/Users.scss';
import {  Button, Form } from 'react-bootstrap';
import UniInput from '../components/UniInput/UniInput';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';
import '../styles/Reports.scss';
import Multiselect from 'multiselect-react-dropdown';
//import { statusToFilter } from '../helpers/utils';
import UniDatePickerRange, { DateOptions } from '../components/UniDatePickerRange/UniDatePickerRange';
import filterIcon from '../assets/icons/filter.svg';
import graph from '../assets/icons/graph.svg';
import documentExcel from '../assets/icons/document-excel.svg';
import tonWeightGreen from '../assets/icons/ton-weight-green.svg';
import documentCancelRed from '../assets/icons/document-cancel-red.svg';
import orderEditBlue from '../assets/icons/order-edit-blue.svg';
import { getAllCustomer} from '../services/customerService';
import { getAllMaterials} from '../services/materialService';
import UniWidgetColumnReport, { UniWidgetColumnOptions } from '../components/UniWidgetColumnReport/UniWidgetColumnReport';
import UniWidgetSummaryReport from '../components/UniWidgetSummaryReport/UniWidgetSummaryReport';
import {GetReportData, ResponseOrderReportData, RequestOrderReportData, getFileReport} from '../services/orderService';
import UniModal from '../components/UniModal/UniModal';
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

type MultiselectOptions = {
    name: string,
    id: string
  };

const Reports = () =>{
    const { i18n, t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(null);
    const [periodValue, setPeriodValue] = useState<string | null>('');
    const [initialDate, setInitialDate] = useState<Date | any>(undefined);
    const [finalDate, setFinalDate] = useState<Date | any>(undefined);
    const [showRangeDates, setShowRangeDates] = useState(false);
    const [currentSelectedFilter, setCurrentSelectedFilter] = useState(1);
    const [optionsCustomers, setOptionsCustomers] = useState<MultiselectOptions[]>([]);
    const [optionsMaterials, setOptionsMaterials] = useState<MultiselectOptions[]>([]);
    const [showDetails, setShowDetails] = useState<boolean>(false);

    const filterOptions = [
        { value: 1, description: t('totalOrders') },
        { value: 2, description: t('cancelledOrders') },
        { value: 3, description: t('updatedOrders') },
    ]
    const [customerSelectedValues, setCustomerSelectedValue] = useState<any>([]);
    const [productSelectedValues, setProductSelectedValue] = useState<any>([]);
    const [origin, setOrigin] = useState<string>('0');
    const [materialType, setMaterialType] = useState<number>();
    const [country, setCountry] = useState<string>();
    const [currentLanguage, setCurrentLanguage] = useState<string>(i18n.language);
    const [reportData, setReportData] = useState<ResponseOrderReportData>();
    const [filteredData, setFilteredData] = useState<UniWidgetColumnOptions[]>([]);

    const multiselectRefMaterials = useRef<any>(null);
    const [errorAccessAs,setErrorAccessAs] = useState('');

    useEffect(() => {
        getCustomersToFilter();
        getMaterialToFilter();
    },[]);

    useEffect(() => {
        if (currentLanguage !== i18n.language) {
            getMaterialToFilter();
            setCurrentLanguage(i18n.language);
            multiselectRefMaterials.current.resetSelectedValues();
        }
    }, [i18n.language]);

    useEffect(() => {
        onChangeFilter(currentSelectedFilter);
    }, [reportData]);

    const onRemoveCustomerMulti = (e: any, s: any) => {
      setCustomerSelectedValue(e);
    }

    const onRemoveProductMulti = (e: any, s: any) => {
        setProductSelectedValue(e);
    }

    const mountPayload = () =>{

        let initialDateParam = initialDate;
        let finalDateParam = finalDate;
        if (typeof(initialDate) === 'object' && typeof(finalDate) === 'object'){
            initialDateParam = moment(initialDate).format('yyyy-MM-DD');
            finalDateParam = moment(finalDate).format('yyyy-MM-DD');
        };

        const customers = customerSelectedValues.map((item: any) => item.id );
        const products = productSelectedValues.map((item: any) => item.id );

        let request: RequestOrderReportData = {
            typeOrder: origin,
            materialType: materialType,
            country: country,
            customerCodes: customers,
            materialCodes: products,
            orderDateInitial: initialDateParam,
            orderDateFinal: finalDateParam
        };

        return request;
    }

    const isValidDate = () =>{

        if (!(initialDate instanceof Date) || !(finalDate instanceof Date)) {
            setErrorAccessAs(t('periodAlert.periodRequired'));
            return false;
        }

        const startDate = new Date(initialDate);
        const endDate = new Date(finalDate);

        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            setErrorAccessAs(t('periodAlert.invalidDate'));
            return false;
        }

        const differenceMs: number = endDate.getTime() - startDate.getTime();
        const differenceDays: number = differenceMs / (1000 * 60 * 60 * 24);

        if (differenceDays > 90) {
            setErrorAccessAs(t('periodAlert.periodNinetyDays'));
            return false;
        }

        return true;
    }

    const getReport = () =>{

        if(!isValidDate()){
            return;
        }
        setShowDetails(origin === "0");

        setLoading(true);

        GetReportData(mountPayload(),i18n.language)
        .then(m => {
            if(m.success){
                setReportData(m.data);
            }
        })
        .catch(e => console.log(e))
        .finally(() => setLoading(false));
    }

    const downloadFile = async (type: string) => {
        if(!isValidDate()){
            return;
        }
        setLoading(true);
        await getFileReport(i18n.language, type, mountPayload()).finally(() => setLoading(false));
    }

    const onChangeCustomerMulti = (e: any, s: any) => {
        console.log(e, s);

        if (e?.some((s: any) => s.id === 0) ?? true) {
            const statusSelected = e?.filter((s: any) => s.id === 0)?.[0];
            if (statusSelected) {
                let index = e?.indexOf(statusSelected);
                e?.splice(index, 1);
            }
        }

        setCustomerSelectedValue(e);
    }

    const onChangeProductMulti = (e: any, s: any) => {
        console.log(e, s);
        if (e?.some((s: any) => s.id === 0) ?? true) {
            const statusSelected = e?.filter((s: any) => s.id === 0)?.[0];
            if (statusSelected) {
                let index = e?.indexOf(statusSelected);
                e?.splice(index, 1);
            }
        }

        setProductSelectedValue(e);
    }

    const getCustomersToFilter = () => {
        const customerOptions: MultiselectOptions[] = [];

        setLoading(true);
        getAllCustomer().then((customers)=> {
            for (let i = 0; i < customers.data.length; i++) {
                const option: MultiselectOptions = {
                    name: customers.data[i].issuerName,
                    id: customers.data[i].issuer
                };

                customerOptions.push(option);
            }
            setOptionsCustomers(customerOptions);
        })
        .catch(() => setOptionsCustomers([]))
        .finally(() => setLoading(false));
    }

    const setDescriptionLanguae = (language:any) =>{
        if(language.toUpperCase() === 'ES')
            return 'ES';
        else
        return 'PT';
    }
    const getMaterialToFilter = () => {
        const materialOptions: MultiselectOptions[] = [];
        setLoading(true);

        getAllMaterials()
            .then((materials) => {
                for (let i = 0; i < materials.materials.length; i++) {
                    const option: MultiselectOptions = {
                        name: materials.materials[i].descriptions.find(c => c.language.toUpperCase() === setDescriptionLanguae(i18n.language))?.description + ' - ' + materials.materials[i].materialCode.replace(/^0+/, '') ?? '-',
                        id: materials.materials[i].materialCode
                    };

                    materialOptions.push(option);
                }
                setOptionsMaterials(materialOptions);
            })
            .catch(() => setOptionsMaterials([]))
            .finally(() => setLoading(false));
    }

    const onChangeDates = (dates: any) => {
        console.log(dates);
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        setPeriodValue(dateRange(start,end));

        setShowRangeDates(false);
        setInitialDate(start);
        setFinalDate(end);
        return;
    };

    const dateRange = (start: any, end: any) => {
        return moment(start).format('DD/MM/yyyy') + ' - ' + moment(end).format('DD/MM/yyyy');
    }

    const onChangeFilter = (value: number) => {
        setCurrentSelectedFilter(value);
        switch (value) {
            case 1:
                setFilteredData(reportData ? reportData.products.map((item) => {
                    return {value: item.quantitiyTonOrders, code: item.materialCode ,description : item.materialDescription}
                }): [] );
                break;
            case 2:
                setFilteredData(reportData ? reportData.products.map((item)=> {
                    return { value: item.quantitiyTonCanceledOrders, code: item.materialCode ,description : item.materialDescription}
                }): [] );
            break;
            case 3:
                setFilteredData(reportData ? reportData.products.map((item)=> {
                    return { value: item.quantityTonOrdersEdited, code: item.materialCode ,description : item.materialDescription}
                }): [] );
            break;
        }
    }

    const calculateSummaryReportValueFontSize = () => {
        if (reportData) {
            const values = [
                reportData.quantitiyTonOrders.toString().length,
                reportData.quantitiyTonCanceledOrders.toString().length,
                reportData.quantitiyTonEditedOrders.toString().length
            ];
            const maxValue = Math.max(...values);
            if (maxValue < 5) {
                return 32;
            } else if (maxValue < 8) {
                return 26;
            }
            return 18;
        }
        return 40;
    }

    const onChangeOrigin = (e: ChangeEvent<HTMLSelectElement>) => {
        setOrigin(e?.target?.value);
    }

    const onChangeMaterialType = (e: ChangeEvent<HTMLSelectElement>) => {
        setMaterialType(parseInt(e?.target?.value));
    }

    const onChangeCountry = (e: ChangeEvent<HTMLSelectElement>) => {
        setCountry(e?.target?.value === '' ? undefined : e?.target?.value);
    }

    return(
        <div className='report-wrapper row'>
            <div className='filter-wrapper col-lg-4'>
                <div className='header'>
                    <div className='menu-icon'>
                    <img src={filterIcon} alt='icone de novo pedido'/>
                     </div>
                     <div className='header'>
                     {t('filterData')}
                     </div>
                </div>
                <div className='body'>
                    <div className='filter'>
                        <Form.Label htmlFor='customers'>{t('customers')}</Form.Label>
                            <Multiselect
                                options={optionsCustomers}
                                onSelect={(e: any, s: any) => onChangeCustomerMulti(e, s)}
                                onRemove={(e: any, s: any) => onRemoveCustomerMulti(e, s)}
                                displayValue='name'
                                placeholder={t('select')}
                                disable={loading}
                                hidePlaceholder
                                showCheckbox
                                showArrow
                            />
                    </div>


                    <div className='filter'>
                        <Form.Label htmlFor='products'>{t('products')}</Form.Label>
                        <Multiselect
                            ref={multiselectRefMaterials}
                            options={optionsMaterials}
                            onSelect={(e: any, s: any) => onChangeProductMulti(e, s)}
                            onRemove={(e: any, s: any) => onRemoveProductMulti(e, s)}
                            displayValue='name'
                            placeholder={t('select')}
                            disable={loading}
                            hidePlaceholder
                            showCheckbox
                            showArrow
                        />
                    </div>

                    <div className='filter'>
                        <UniInput
                            id='origin'
                            label={t('origin')}
                            isSelect
                            value={origin ?? '0'}
                            onChange={(e) => onChangeOrigin(e)}
                            disabled={loading}
                        >
                            <option value={'0'}>{t('reportOrigin.general')}</option>
                            <option value={'1'}>{t('reportOrigin.web')}</option>
                            <option value={'2'}>{t('reportOrigin.sap')}</option>
                        </UniInput>
                    </div>

                    <div className='filter'>
                        <UniInput
                            id='group'
                            label={t('group')}
                            isSelect
                            value={materialType}
                            onChange={(e) => onChangeMaterialType(e)}
                            disabled={loading}
                        >
                            <option value={undefined}>{t('all')}</option>
                            <option value={0}>{t('reportMaterialType.pvc')}</option>
                            <option value={1}>{t('reportMaterialType.chemical')}</option>
                        </UniInput>
                    </div>

                    <div className='filter'>
                        <UniInput
                            id='country'
                            label={t('country')}
                            isSelect
                            value={country}
                            onChange={(e) => onChangeCountry(e)}
                            disabled={loading}
                        >
                            <option value={''}>{t('all')}</option>
                            <option value={'AR'}>{'AR'}</option>
                            <option value={'BR'}>{'BR'}</option>
                        </UniInput>
                    </div>

                    <div className='filter'>
                        <UniDatePickerRange
                            loading={loading}
                            periodValue={periodValue}
                            onChange={e => onChangeDates(e)}
                            options={[]}
                            onHideChange={() => setShowRangeDates(!showRangeDates)}
                        />
                    </div>

                    <div className='buttons-apply-filter'>
                        <Button
                            onClick={() => getReport()}
                            disabled={loading}
                            title={t('applyFilter')}
                        >
                            {t('applyFilter')}
                        </Button>
                    </div>
                </div>
            </div>
            <div className='dois col-lg-8'>
                <div className='row title-export-buttons'>
                    <div className='col report-title'>
                        <img src={graph} alt='graph' /> {t('viewingData')}
                    </div>
                    <div className='export-orders'>
                        <button disabled={loading} onClick={() => downloadFile('orders')}>
                            <img src={documentExcel} alt='documentExcel' /> {t('exportOrders')}
                        </button>
                    </div>
                    <div className='export-customers'>
                        <button disabled={loading} onClick={() => downloadFile('customers')}>
                            <img src={documentExcel} alt='documentExcel' /> {t('exportCustomers')}
                        </button>
                    </div>
                </div>
                <div className='row report-card-summary'>
                    {
                        loading ? (
                            <Skeleton
                                height={162}
                                style={{ marginBottom: 13 }}
                                highlightColor={'#f5f5f5'}
                                baseColor={'#ebebeb'} />
                        ) : (
                                <>
                                    <UniWidgetSummaryReport
                                        title={filterOptions[0].description}
                                        iconImg={tonWeightGreen}
                                        iconBackgroundColor='#E6FFEC'
                                        value={reportData?.quantitiyTonOrders ?? 0}
                                        buttonValue={reportData?.quantityOrders ?? 0}
                                        valueFontSize={calculateSummaryReportValueFontSize()}
                                        onButtonClick={() => onChangeFilter(1)}
                                        isButtonActive={currentSelectedFilter === 1}
                                        valueDetail= { showDetails ? 'SAP ' + reportData?.quantitiyTonOrdersSAP + ' t (' + reportData?.quantityOrdersSAP + ' ' + t('report.orders') + ')': ''}
                                        valueDetailTwo = { showDetails ? t('report.portal') + ' ' + reportData?.quantitiyTonOrdersPortal  + ' t (' + reportData?.quantityOrdersPortal + ' ' + t('report.orders') + ')': ''}

                                    />
                                    <UniWidgetSummaryReport
                                        title={filterOptions[1].description}
                                        iconImg={documentCancelRed}
                                        iconBackgroundColor='#FFE4E4'
                                        value={reportData?.quantitiyTonCanceledOrders ?? 0}
                                        buttonValue={reportData?.quantityOrdersCanceled ?? 0}
                                        valueFontSize={calculateSummaryReportValueFontSize()}
                                        onButtonClick={() => onChangeFilter(2)}
                                        isButtonActive={currentSelectedFilter === 2}
                                        valueDetail= { showDetails ? 'SAP ' + reportData?.quantitiyTonCanceledOrdersSAP + ' t (' + reportData?.quantityOrdersCanceledSAP + ' ' + t('report.orders') + ')': ''}
                                        valueDetailTwo = { showDetails ? t('report.portal') + ' ' + reportData?.quantitiyTonCanceledOrdersPortal + ' t (' + reportData?.quantityOrdersCanceledPortal + ' ' + t('report.orders') + ')': ''}
                                    />
                                    <UniWidgetSummaryReport
                                        title={filterOptions[2].description}
                                        iconImg={orderEditBlue}
                                        iconBackgroundColor='#E4F9FF'
                                        value={reportData?.quantitiyTonEditedOrders ?? 0}
                                        buttonValue={reportData?.quantityEditedOrders ?? 0}
                                        valueFontSize={calculateSummaryReportValueFontSize()}
                                        onButtonClick={() => onChangeFilter(3)}
                                        isButtonActive={currentSelectedFilter === 3}
                                    />
                                </>
                        )
                    }
                </div>
                <div className='by-products row'>
                    {
                        loading ? (
                            <Skeleton
                                height={450}
                                highlightColor={'#f5f5f5'}
                                baseColor={'#ebebeb'}
                            />
                    ) : (
                        <UniWidgetColumnReport
                            title={t('byProducts')}
                            options={filteredData}
                            filterOptions={filterOptions}
                            onChangeFilter={onChangeFilter}
                            currentSelectedFilter={currentSelectedFilter}
                            columnReportHeight={165}
                        />
                    )}
                </div>
            </div>
            <UniModal
                icon={faXmarkCircle}
                message=''
                iconColor='#EA2027'
                title={errorAccessAs}
                onHide={() => {setErrorAccessAs('')}}
                show={errorAccessAs !== ''}
                isFontAwsome
            />
        </div>
    );
}

export default Reports;